import { initializeApp } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";
import { getFunctions } from 'firebase/functions';
import { getMessaging, isSupported } from 'firebase/messaging';
import { getAuth } from "firebase/auth";

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);
// console.log("🔥 Conectado a Firebase Project:", process.env.REACT_APP_PROJECT_ID);
// Inicializar servicios
// =====================================================================
// 🛡️ FIX: "Fetch API cannot load .../Listen/channel ... due to access
// control checks" en Safari — Safari bloquea, por sus reglas de
// privacidad, el mecanismo de streaming (WebChannel) que usa Firestore
// por default para las escuchas en tiempo real (onSnapshot). En vez de
// getFirestore(app) simple, se usa initializeFirestore(app, {...}) con
// detección automática de long-polling: si el streaming normal falla,
// Firestore cambia solo a un mecanismo más compatible (polling), sin
// que se note del lado de la app — sigue funcionando en tiempo real
// igual, solo con un transporte distinto por debajo.
// =====================================================================
export const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
  useFetchStreams: false,
});
export const storage = getStorage(app);
export const functions = getFunctions(app);

// =====================================================================
// 🛡️ FIX: "pantalla en blanco"/"Barbería no encontrada" en Safari e
// Instagram — getMessaging(app) ANTES corría acá mismo, sin protección,
// apenas se cargaba este archivo (antes de que React pintara nada). En
// navegadores que no soportan las APIs que necesita FCM (ciertas
// versiones/configuraciones de Safari, navegadores embebidos como el de
// Instagram) esto tira un error de entrada — y como este archivo lo
// importa TODO App.js, si esto se cae, se cae la aplicación entera,
// aunque el problema real sea solo "no hay notificaciones push acá".
//
// La solución: primero se pregunta con isSupported() (asíncrono, nunca
// tira error) si el navegador puede usar Messaging. Si no puede,
// "messaging" queda en null — el resto de la app (reservas, chat,
// caja, todo) sigue funcionando exactamente igual, simplemente sin
// notificaciones push en ESE navegador puntual. Código que usa
// "messaging" en App.js debe chequear que no sea null antes de usarlo
// (ej: "if (messaging) { onMessage(messaging, ...) }").
// =====================================================================
export let messaging = null;
isSupported()
  .then((soportado) => {
    if (!soportado) {
      console.warn('⚠️ Este navegador no soporta Firebase Messaging — notificaciones push desactivadas (el resto de la app funciona normal).');
      return;
    }
    try {
      messaging = getMessaging(app);
    } catch (e) {
      console.warn('⚠️ No se pudo inicializar Firebase Messaging:', e.message);
    }
  })
  .catch((e) => {
    console.warn('⚠️ Error verificando soporte de Firebase Messaging:', e.message);
  });

// 👇 2. INICIALIZAR Y EXPORTAR AUTH (Esto es lo que faltaba)
export const auth = getAuth(app);